import {ArianeElement} from "./ariane.resources.provided";
import {BehaviorSubject, Observable} from "rxjs/Rx";
import {Injectable} from "@angular/core";

@Injectable()
export class ArianeStore {

    private elements: Array<ArianeElement>;
    private onElementsUpdateObs: BehaviorSubject<Array<ArianeElement>>;

    constructor() {
        this.elements = new Array<ArianeElement>();
        this.onElementsUpdateObs = new BehaviorSubject(this.elements);
    }

    updateElements(elements: Array<ArianeElement>) : void {
        this.elements = elements;
        this.onElementsUpdateObs.next(this.elements);
    }

    onElementsUpdate(): Observable<Array<ArianeElement>> {
        return this.onElementsUpdateObs.asObservable();
    }

    getElements() : Array<ArianeElement>{
        return this.elements;
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/ariane/ariane.store.ts